module.exports = __webpack_public_path__ + "static/media/stuffednightcap.3cb379df.png";